import React from "react";
import { Pagination } from "@bookingcom/bui-react";
import useSearchPaginationController from "./useSearchPagination.controller.js";
export default function SearchPaginationDesktop() {
    const { totalPages, currentPage, ariaPreviousLabel, ariaNextLabel, ariaPageLabelPrefix, onPageChange, canRender } = useSearchPaginationController();
    return canRender ? (React.createElement("nav", null,
        React.createElement(Pagination, { totalPages: totalPages, currentPage: currentPage, ariaPreviousLabel: ariaPreviousLabel, ariaNextLabel: ariaNextLabel, ariaPageLabelPrefix: ariaPageLabelPrefix, onPageChange: onPageChange, attributes: { style: { justifyContent: "center" } } }))) : null;
}
